interface ModelMetadata {
	provider: string;
	model: string;
}

interface MessageWithModelMetadata {
	role: string;
	metadata?: {
		custom?: Record<string, unknown>;
	};
}

function getMessageModel(message: MessageWithModelMetadata | undefined): ModelMetadata | undefined {
	if (message?.role !== 'assistant') {
		return undefined;
	}

	const model = message.metadata?.custom?.['model'];
	if (model === null || typeof model !== 'object') {
		return undefined;
	}

	const provider = (model as Record<string, unknown>)['provider'];
	const modelName = (model as Record<string, unknown>)['model'];
	if (typeof provider !== 'string' || typeof modelName !== 'string') {
		return undefined;
	}

	return { provider, model: modelName };
}

/**
 * Returns the model label to render before a message, if that message begins a
 * model segment. The first known model is anchored above the whole transcript.
 */
export function getModelSetLabel(
	messages: readonly MessageWithModelMetadata[],
	messageIndex: number,
): string | undefined {
	if (messageIndex === 0) {
		for (const message of messages) {
			const model = getMessageModel(message);
			if (model !== undefined) {
				return model.model;
			}
		}
		return undefined;
	}

	const currentModel = getMessageModel(messages[messageIndex]);
	if (!currentModel) {
		return undefined;
	}

	let previousModel: ModelMetadata | undefined;
	for (let index = messageIndex - 1; index >= 0; index--) {
		const model = getMessageModel(messages[index]);
		if (model !== undefined) {
			previousModel = model;
			break;
		}
	}

	if (!previousModel) {
		return undefined;
	}

	return previousModel.provider === currentModel.provider && previousModel.model === currentModel.model ?
			undefined
		:	currentModel.model;
}
